import { Badge } from "../../components/ui/Badge";
import { formatUsdcRaw, shortAssetId } from "../../lib/format";
import type { TradeRow } from "./rows";

export function TradePlan({ trades }: { trades: TradeRow[] }) {
	return (
		<div className="space-y-3">
			<h3 className="text-xs font-semibold uppercase tracking-wide text-slate-400">
				Trade plan ({trades.length} {trades.length === 1 ? "leg" : "legs"})
			</h3>
			{trades.length === 0 ? (
				<p className="rounded-md border border-slate-800 bg-slate-900/40 p-3 text-xs text-slate-400">
					Already on target — no trades needed.
				</p>
			) : (
				<div className="overflow-hidden rounded-lg border border-slate-800">
					<table className="w-full text-sm">
						<tbody className="divide-y divide-slate-800">
							{trades.map((t) => (
								<tr key={t.assetId}>
									<td className="px-3 py-2 font-mono text-xs text-slate-200">
										{shortAssetId(t.assetId, 28)}
									</td>
									<td className="px-3 py-2 w-16">
										<Badge tone={t.side === "buy" ? "positive" : "negative"}>
											{t.side}
										</Badge>
									</td>
									<td className="px-3 py-2 text-right font-mono">
										{formatUsdcRaw(t.deltaUsdcRaw)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
}
